export function insertItemAfterIdInPlace<T extends { id: string }>(items: T[], targetId: string, newItem: T) {
  const targetIndex = items.findIndex(item => item.id === targetId);

  if (targetIndex === -1) {
    items.push(newItem);
  } else {
    items.splice(targetIndex + 1, 0, newItem);
  }
}
